/**
 * Created by RKL on 21/08/2015.
 */
define('ordersShowViewDesign2',[
  'module',
  'underscore',
  'backbone',
  'jqgridView',
  'dateUtils',
  'urlUtil',
  'app',
  'settings',
  'template!ordersViewTpl',
  'logotoolUtils',
  'datePickerPopoverMixin',
  'jqgridActionsButtonFormatterActions',
  'jqgridActionsButtonFormatterView',
  'bootbox'
], function(
  module,
  _,
  Backbone,
  JqGridView,
  dateConverter,
  UrlUtil,
  App,
  Settings,
  viewTpl,
  logotoolUtils,
  datePickerPopoverMixin,
  availableActions,
  ActionButtonsView,
  bootbox
) {
  'use strict';

  var OrdersView =  JqGridView.extend({
    template: viewTpl,
    filtersName: 'ordersFilters',

    regions: {
      ordersActions: '.js-action-buttons-region'
    },

    onShow: function() {
      $.material.init();
      this.updateExportUrl({});
      this.createActionButtonView();
    },

    ui: function() {
      return _.extend({
        jqGrid: '#jq-grid-list',
        jqGridPager: '#jq-grid-pager-list',
        downloadPdf: '.orders-pdf-download',
        payedByCustomerCheckbox: '.js-ticket-payed-by-customer[type=checkbox]',
        payedToManufacturerCheckbox: '.js-ticket-payed-to-manufacturer[type=checkbox]'
      }, this.gridUi);
    },

    events: function() {
      return _.extend({
        'change @ui.payedByCustomerCheckbox': 'onPayedByCustomerCheckbox',
        'change @ui.payedToManufacturerCheckbox': 'onPayedToManufacturerCheckbox'
      }, this.gridEvents);
    },

    onPayedByCustomerCheckbox: function(e) {
      var that = this,
        $input = $(e.currentTarget),
        orderId = $input.data('order-cid'),
        checked = $input.is(':checked');

        that.trigger('order:update', {purchaseOrderId: orderId, payedByCustomer: checked });
    },

    onPayedToManufacturerCheckbox: function(e) {
      var that = this,
        $input = $(e.currentTarget),
        orderId = $input.data('order-cid'),
        checked = $input.is(':checked');

        that.trigger('order:update', {purchaseOrderId: orderId, payedToManufacturer: checked });
    },

    serializeData: function () {
      this.selectedOrders = Settings.get('selectedOrders') || [];
      var templateData = {
        'type': 'orders'
      };
      if (this.options.endUserSecId) {
        templateData.newOrderLogotoolUrl = logotoolUtils.getLogotoolCataloguesUrl({
          endUserSecId: this.options.endUserSecId,
          returnUrl: UrlUtil.addPathParam('orders')
        });
      } else {
        templateData.newOrderLogotoolUrl =  logotoolUtils.getLogotoolCataloguesUrl({
          returnUrl: window.location.href,
          endUserSecId: 'new'
        });
      }
      return templateData;
    },

    gridOptions: function(data) {
      var that = this,
        defaultsOptions = this.gridInitOptions(data),
        options = {
          colModel: [
              {
                  label: ' ',
                  name: 'snapshotsUids',
                  align: 'left',
                  classes: 'order-link image-cell',
                  formatter: this.pictureUidFormatter,
                  width: 80,
                  search: false
              },{
                  label: _.i18n('orderList.agentId'),
                  name: 'agentId',
                  classes: 'order-link',
                  formatter: this.defaultFormatter,
                  search: true,
                  index: 'agentId',
                  key: true
              },{
                  label: _.i18n('orderList.orderNumber'),
                  name: 'externalNumber',
                  classes: 'order-link',
                  formatter: this.defaultFormatter,
                  search: true,
                  index: 'externalNumber',
                  key: true
                },{
                label: _.i18n('orderList.configurationNumber'),
                name: 'purchaseOrderId',
                classes: 'order-link',
                formatter: this.defaultFormatter,
                search: true,
                index: 'purchaseOrderId',
                key: true
              },
            {
              label: _.i18n('orderList.endUser'),
              name: 'endUserId',
              classes: 'order-link',
              formatter: this.defaultFormatter,
              search: true,
              index: 'endUserId'
            }, {
              label: _.i18n('orderList.orderCreatDate'),
              name: 'createDate',
              classes: 'order-link',
              formatter: this.dateFormatter,
              search: true,
              index: 'createDate',
              sorttype: 'date', 
              searchrules: {date: true},
              searchoptions: {
                dataInit: datePickerPopoverMixin.jqGridDataInit
              },
              width: 130
            }, {
              label: _.i18n('orderList.productCode'),
              name: 'productCode',
              classes: 'order-link',
              formatter: this.defaultFormatter,
              search: true,
              index: 'productCode'
            }, {
              label: _.i18n('orderList.productName'),
              name: 'productName',
              classes: 'order-link',
              formatter: this.defaultFormatter,
              search: true,
              index: 'productName'
            }, {
              label: _.i18n('orderList.status'),
              name: 'status',
              classes: 'order-link',
              search: true,
              index: 'status',
              formatter: this.commandTypeFormatter,
              stype: 'select',
              searchrules: {select: true},
              searchoptions: {
                value: data.statuses,
                defaultValue: that.selectDefault
              }
            }
          ],

          serializeGridData: function (postData) {
            if (postData.status === that.selectDefault) {
              delete postData.status;
            }

            if (postData.createDate) {
              postData.dateFrom = datePickerPopoverMixin.parseDateFrom(postData.createDate);
              postData.dateTo = datePickerPopoverMixin.parseDateTo(postData.createDate);
            } else if (!that.sorting) {
              delete postData.dateFrom;
              delete postData.dateTo;
            }
            that.sorting = false;
            defaultsOptions.serializeGridData.apply(this, arguments);


            return postData;
          },

          dateFormatter: function(cellvalue) {
            var date = dateConverter.toDateFormatString(cellvalue),
              time = dateConverter.toTimeFormatString(cellvalue);

            return '<span class="cell-date">' + date + ' ' + time + '</span>';
          },

          gridComplete: function() {
            var purchaseOrderId = UrlUtil.parseQueryString().purchaseOrderId;
            if(purchaseOrderId) {
              UrlUtil.clearQueryString();
              that.preselectFirstRow();
            }
            defaultsOptions.gridComplete.apply(this, arguments);
            that.checkOrdersSelection();
          },

          beforeSelectRow: function(rowid, event) {
            // check if order selection
            var grid = $(this);
            if (event.ctrlKey || event.altKey) {  // alt instead ctrl for mac os
              that.manageCtrlKey(grid, rowid);
            } else if (event.shiftKey) {
              that.manageShiftKey(grid, rowid);
            } else {
              return true;
            } 
            return false;
          },

          onSelectRow: function(rowId, bool, e) {
            var cellUpdated = that.$('.cell-payedToManufacturer, .cell-payedByCustomer');

            if (e && e.type === 'click' && cellUpdated.has(e.target).length === 0 && App.getCurrentRoute() === 'orders') {
              var route = App.getCurrentRoute() ===  'orders' ? App.getCurrentRoute() : 'orders/' + App.getCurrentRoute();
              App.navigate(route + '/' + rowId, {trigger: true});
            }
          }
        };

      options = _.defaults(options, defaultsOptions);

      return options;
    },

    /*
     * orders selection with ctrl/shift keys
    */

    manageCtrlKey: function(grid, rowid) {
      var maxSelectedOrdersNumber = 100,
          $row = grid.find('#' + rowid);
      if ($row.hasClass('selected')) {
        $row.removeClass('selected');
        this.onRowMultiselect(rowid, false);
      } else {
        if (this.selectedOrders.length === maxSelectedOrdersNumber) {
          this.showWarningSelectedNumberOutOfRange();
        } else {
          $row.addClass('selected');
          this.onRowMultiselect(rowid, true);
        }
      }
    },

    manageShiftKey: function(grid, rowid) {
      var firstSelectedOrder = this.getFirstSelectedOrder(),
          lastSelectedRow = grid.find('#' + rowid),
          gridRows = grid.find('tr'),
          lastIndex = gridRows.index(lastSelectedRow),
          lastSelectedOrder = {
            rowid: rowid,
            page: this.pagination.currentPage,
            index: lastIndex
          };

      if (!firstSelectedOrder) firstSelectedOrder = lastSelectedOrder;
      if (firstSelectedOrder.page > lastSelectedOrder.page) {
        this.swapOrders(firstSelectedOrder, lastSelectedOrder);
      } else if (firstSelectedOrder.page === lastSelectedOrder.page){
        if (firstSelectedOrder.index > lastSelectedOrder.index) {
          this.swapOrders(firstSelectedOrder, lastSelectedOrder);
        }
      }
      if (this.checkIfOnlyCurrentPageSelection(firstSelectedOrder, lastSelectedOrder)) {
        this.selectWithoutRequest(firstSelectedOrder, lastSelectedOrder);
      } else {
        this.getCollectionToPage(firstSelectedOrder, lastSelectedOrder);
      }
    },

    checkIfOnlyCurrentPageSelection: function (first, last) {
      return first.page === last.page;
    },

    selectWithoutRequest: function (first, last) {
      var grid = this.ui.jqGrid,
          list = grid.find('tr');

      this.selectedOrders = [];
      list.each(_.bind(function(index, row){
        var $row = $(row),
            rowid = $row.attr('id');
        if (index >= first.index && 
            index <= last.index) {
          this.selectedOrders.push({
            rowid: rowid,
            page: this.pagination.currentPage,
            index: index
          });
        }
      }, this));
      this.checkOrdersSelection();
    },

    swapOrders: function(first, last) {
      for (var key in last) {
        var temp = first[key];
        first[key] = last[key];
        last[key] = temp;
      }
    },

    getFirstSelectedOrder: function() {
      var firstSelected,
          lastPage = this.getLastPage(), 
          firstIndex = this.pagination.pageSize;
      if (this.selectedOrders.length === 0) {
        return null;
      } else {
        _.each(this.selectedOrders, function(order){
           if (order.page < lastPage) {
            lastPage = order.page;
            firstIndex = order.index;
            firstSelected = order;
           } else if (order.page === lastPage) {
            if (order.index < firstIndex) {
              firstSelected = order;
              firstIndex = order.index;
            }
           }
        });
        return firstSelected;
      }
    },

    getLastPage: function() {
      var lastPage;
      if (this.selectedOrders.length > 0) {
        lastPage = _.max(this.selectedOrders, function(order){ 
          return order.page; 
        }).page;
      } else {
        lastPage = this.pagination.currentPage;
      }
      return lastPage;
    },

    getCollectionToPage: function (first, last) {
      var firstOrderIndex = (first.page - 1 ) * this.pagination.pageSize + (first.index - 1),
          lastOrderIndex = (last.page - 1 ) * this.pagination.pageSize + last.index,
          size = lastOrderIndex - firstOrderIndex || 1,
          params = {
            pageSize: size,
            first: firstOrderIndex,
            _search: false,
            nd: new Date().getTime(),
            rows: size,
            page: 1,
            sord: 'asc'
          };
      if (size > 100) {
        this.showWarningSelectedNumberOutOfRange();
      } else {
        $('#content-blinder').show();
        this.trigger('onLoadSelectedOrders', first, last, params);
      }
    },

    showWarningSelectedNumberOutOfRange: function() {
      bootbox.alert(_.i18n('common.errorOccuredSelectedItemsNumberOutOfRange'), function () {
        return;
      });
    },

    onSelectOrders: function(first, last, orders) {
      var pageSize = this.pagination.pageSize,
          page, orderIndex;

      this.selectedOrders = [];
      _.each(orders, _.bind(function(order, index) {
        page = Math.floor((index + first.index - 1) / pageSize);
        orderIndex = index + first.index - page * pageSize;
        this.selectedOrders.push({
          rowid: order,
          page: page + first.page,
          index: orderIndex
        });
      }, this));
      this.checkOrdersSelection();
    },

    onRowMultiselect: function(rowid, select) {
      var index,
          grid = this.ui.jqGrid,
          gridList = grid.find('tr'),
          row = grid.find('#' + rowid),
          order = {
            rowid: rowid,
            page: this.pagination.currentPage,
            index: gridList.index(row)
          };
      if (select) {
        this.selectedOrders.push(order);
      } else {
        index = this.selectedOrders.indexOf(_.findWhere(this.selectedOrders, {rowid: rowid}));
        this.selectedOrders.splice(index, 1);
      }
      this.onSelectedOrdersChanged();
    },

    createActionButtonView: function() {
      this.actionsButtonView = this._getActionButtonsView();
      this.listenTo(this.actionsButtonView, 'action', this._onAction);
      this.getRegion('ordersActions').show(this.actionsButtonView);
      this.actionsButtonView.setButtonsState({
        'proofsheet': false,
        'export': false
      });
    },

    _getActionButtonsView: function() {
      var actions = ['proofsheet', 'export'],
        actionsCollection = new Backbone.Collection();
      _.each(actions, function(action) {
        actionsCollection.push(availableActions[action]);
      });

      return new ActionButtonsView({
        collection: actionsCollection,
        dontShowIcons: true
      });
    },

     _onAction: function(action) {
      switch(action) {
        case 'proofsheet':
          this.downloadProofsheets();
          break;
        case 'export':
          this.exportOrders();
          break;
        default :
          throw 'Action is not supported';
      }
    },

    checkOrdersSelection: function() {
      var $list = this.ui.jqGrid.find('tr');
      $list.each(_.bind(function (index, item) {
        var $item = $(item);
        if (_.some(this.selectedOrders, {rowid: $item.attr('id')})) {
          $item.addClass('selected');
        } else {
          $item.removeClass('selected');
        }
      }, this));
      this.onSelectedOrdersChanged();
    },

    onSelectedOrdersChanged: function() {
      if (this.selectedOrders.length > 0) {
        this.actionsButtonView.setButtonsState({
          'proofsheet': true,
          'export': true
        });
      } else {
        this.actionsButtonView.setButtonsState({
          'proofsheet': false,
          'export': false
        });
      }
      Settings.set('selectedOrders', this.selectedOrders);
    },

    downloadProofsheets: function() {
      this.downloadPdf('prf');
    },

    exportOrders: function() {
      this.downloadPdf('pzi');
    },

    downloadPdf: function(docType) {
        var orders = [];
        _.each(this.selectedOrders, function(order){
          orders.push(order.rowid);
        });
        window.open(App.request('order:get-pdf-url', {
            docType: docType,
            poi: orders
        }));
    },

    personalizedFormatter: function(cellvalue, options, rowObj) {
        var checked = rowObj.personalized ? 'checked' : '',
            htmlEl = '<div class="form-group checkbox-group">' +
                '<div class="checkbox checkbox-primary"><label>' +
                '<input disabled="disabled" type="checkbox" data-ticket-cid="' + options.rowId +
                '" class="js-ticket-urgent" ' + checked + ' ' +
                '></label></div></div>';
        return htmlEl;
    },

    payedByCustomerFormatter: function(cellValue, options, rowObj) {
      var checked = rowObj.payedByCustomer ? 'checked' : '',
        htmlEl = '<div class="form-group checkbox-group">' +
                 '<div class="checkbox checkbox-primary"><label>' +
                 '<input  type="checkbox" data-order-cid="' + options.rowId +
                 '" class="js-ticket-payed-by-customer" ' + checked + ' ' +
                 '></label></div></div>';
      return htmlEl;
    },

    payedToManufacturerFormatter: function(cellValue, options, rowObj) {
      var checked = rowObj.payedToManufacturer ? 'checked' : '',
        htmlEl = '<div class="form-group checkbox-group">' +
                 '<div class="checkbox checkbox-primary"><label>' +
                 '<input type="checkbox" data-order-cid="' + options.rowId +
                 '" class="js-ticket-payed-to-manufacturer" ' + checked + ' ' +
                 '></label></div></div>';
      return htmlEl;
    },

    commandTypeFormatter:function(cellValue, options) {
      if (cellValue === null || cellValue === undefined) { cellValue = ''; }

      var statuses = [], statusValue;

      if (options.colModel.searchoptions.value) {
        statuses = options.colModel.searchoptions.value.split(';');
      }

      _.each(statuses, function(status) {
        var st = status.split(':');
        if (st.length === 2) {
          if (st[0] === cellValue) {
            statusValue = st[1];
          }
        }
      });

      if (!statusValue) {
        statusValue = _.i18n('commandstatus.'+cellValue.toLowerCase());
      }

      return '<span class="cell-default" data-row-id="' +
          options.rowId + '">' + statusValue + '</span>';
    },
    updateExportUrl: function(data){
        this.$el.find('.orders-export').attr('href',  App.request('order:get-excel-url', data));
    },
    onGridFilterChange: function() {
      var that = this,
        filters = {},
        value;

      _.each(this.colModel, function(column) {
        if (column.search) {
          if (column.stype === 'select') {
            value = that.$('select[name="' + column.index + '"]').val();
            filters[column.index] = value === that.selectDefault ? '' : value;
          } else if (column.sorttype === 'date') {
            value = that.$('input[name="' + column.index + '"]').val();
            if (column.index === 'createDate' && value) {
              filters.dateFrom = datePickerPopoverMixin.parseDateFrom(value);
              filters.dateTo = datePickerPopoverMixin.parseDateTo(value);
            }
          } else {
            value = that.$('input[name="' + column.index + '"]').val();
            filters[column.index] = value;
          }
        }
      });

      this.filters = filters;
      this.filterChange = true;
      this.updatePagination();
      this.updateExportUrl(filters);
    }
  });

  module.exports = OrdersView;
});
